import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function RechercheInnovations() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).style.opacity = "1";
            (entry.target as HTMLElement).style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".fade-in-up").forEach((el) => {
      (el as HTMLElement).style.opacity = "0";
      (el as HTMLElement).style.transform = "translateY(30px)";
      (el as HTMLElement).style.transition = "opacity 0.7s ease, transform 0.7s ease";
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <Navbar />

      {/* Hero */}
      <section className="pt-20 min-h-[70vh] flex flex-col lg:flex-row">
        {/* Text Side */}
        <div className="w-full lg:w-1/2 flex items-center px-8 md:px-16 py-20 bg-white order-2 lg:order-1">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-500 mb-4 fade-in-up">
              Avant-garde
            </p>
            <div className="flex items-start gap-4 mb-6 fade-in-up">
              <div className="w-1 h-16 bg-amber-500 flex-shrink-0 mt-1" />
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                Recherche &amp;<br />Innovations
              </h1>
            </div>
            <p className="text-gray-600 text-base leading-relaxed max-w-md mb-10 fade-in-up">
              Accompagnement dans les projets inventifs, incluant santé alternative et crypto actifs. Une vision tournée vers l&apos;avenir pour des solutions de demain.
            </p>

            {/* Néogénératrice Button */}
            <a
              href="https://www.facebook.com/Zictora1/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="fade-in-up inline-flex items-center gap-3 bg-gray-900 text-white px-8 py-4 rounded-lg font-semibold text-sm tracking-wide hover:bg-gray-800 transition-all duration-300 cursor-pointer whitespace-nowrap group"
            >
              <i className="ri-flask-line text-amber-400" />
              Néogénératrice
              <span className="w-6 h-6 flex items-center justify-center bg-amber-500 rounded-full group-hover:bg-amber-400 transition-colors duration-200">
                <i className="ri-arrow-right-line text-white text-xs" />
              </span>
            </a>
          </div>
        </div>

        {/* Photo Side */}
        <div className="w-full lg:w-1/2 h-64 lg:h-auto relative overflow-hidden order-1 lg:order-2">
          <img
            src="https://readdy.ai/api/search-image?query=futuristic%20research%20and%20innovation%20laboratory%20with%20glowing%20technology%20elements%2C%20scientist%20working%20with%20holographic%20displays%2C%20dark%20background%20with%20teal%20and%20amber%20light%20accents%2C%20cutting%20edge%20technology%2C%20modern%20science%20environment%2C%20professional%20photography&width=800&height=900&seq=recherche-hero-001&orientation=portrait"
            alt="Recherche & Innovations"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-white/10" />
        </div>
      </section>

      {/* Links Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-500 mb-12 text-center fade-in-up">
            Domaines d&apos;innovation
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Santé + */}
            <a
              href="https://Facebook.com/profile.php?id=100087804773644"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="fade-in-up bg-white rounded-lg p-10 border border-gray-100 hover:border-amber-200 hover:shadow-md transition-all duration-300 group cursor-pointer flex flex-col items-center text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-amber-50 rounded-full mb-6 group-hover:bg-amber-100 transition-colors duration-300">
                <i className="ri-heart-pulse-line text-3xl text-amber-500" />
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-3">Santé +</h2>
              <p className="text-gray-500 text-sm leading-relaxed mb-6">
                Solutions innovantes en santé alternative pour améliorer votre bien-être et votre vitalité.
              </p>
              <span className="inline-flex items-center gap-2 text-xs font-semibold text-amber-600 group-hover:text-amber-700 transition-colors duration-200">
                <i className="ri-facebook-circle-fill" />
                Voir sur Facebook
                <i className="ri-arrow-right-line" />
              </span>
            </a>

            {/* Cryptoca$h */}
            <a
              href="https://Facebook.com/profile.php?id=100086018067702"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="fade-in-up bg-white rounded-lg p-10 border border-gray-100 hover:border-amber-200 hover:shadow-md transition-all duration-300 group cursor-pointer flex flex-col items-center text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-amber-50 rounded-full mb-6 group-hover:bg-amber-100 transition-colors duration-300">
                <i className="ri-bit-coin-line text-3xl text-amber-500" />
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-3">Cryptoca$h</h2>
              <p className="text-gray-500 text-sm leading-relaxed mb-6">
                Exploration et accompagnement dans l&apos;univers des crypto actifs et des nouvelles technologies financières.
              </p>
              <span className="inline-flex items-center gap-2 text-xs font-semibold text-amber-600 group-hover:text-amber-700 transition-colors duration-200">
                <i className="ri-facebook-circle-fill" />
                Voir sur Facebook
                <i className="ri-arrow-right-line" />
              </span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
